export interface CompanionAd {
  id: string;
  width: number;
  height: number;
  code?: string;
  altText?: string;
  clickThroughURL?: string;
  clickTrackingURL?: string;
  resourceType?: ResourceType;
  creativeView: string[];
  creativeType?: string;
  expandedWidth?: number;
  expandedHeight?: number;
  url?: string;
  adParameters?: string;
}

export enum ResourceType {
  HTML = 'html',
  STATIC = 'static',
  IFRAME = 'iframe',
}
